import React from "react";

// Accessible multi-select rendered as a group of toggle buttons.
// Native <button> elements => keyboard accessible by default; selection state
// is exposed via aria-pressed. No dropdown hides the choices.
export const MultiSelectOptionGroup = ({
  legendId,
  options,
  selected,
  onToggle,
  testIdFor,
  invalid,
  errorId,
  disabled,
}) => {
  return (
    <div
      role="group"
      aria-labelledby={legendId}
      aria-invalid={invalid || undefined}
      aria-describedby={invalid ? errorId : undefined}
      className="flex flex-wrap gap-2.5"
    >
      {options.map((opt) => {
        const isSelected = selected.includes(opt.code);
        return (
          <button
            key={opt.code}
            type="button"
            data-testid={testIdFor(opt.code)}
            aria-pressed={isSelected}
            disabled={disabled}
            onClick={() => onToggle(opt.code)}
            className={[
              "corex-option font-condensed tracking-wide uppercase text-sm",
              "px-4 py-2.5 rounded-sm border transition-colors duration-200",
              "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B872] focus-visible:ring-offset-2 focus-visible:ring-offset-black",
              "disabled:opacity-50 disabled:cursor-not-allowed",
              isSelected
                ? "border-[#C8A24C] bg-[#C8A24C]/15 text-[#E7CA86]"
                : "border-white/20 text-white/80 hover:border-white/45 hover:text-white",
            ].join(" ")}
          >
            {opt.label}
          </button>
        );
      })}
    </div>
  );
};
